import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { ContactOutput } from '../model/contact.output';

export interface AddContactColumnInput {
	readonly id: string;
	readonly columnId: string;
	readonly moduleId: string;
}

export interface AddContactColumnParams {
	input: AddContactColumnInput;
}

@Injectable({ providedIn: 'root' })
export class AddContactColumnApiMutation extends ApiMutation<
	ContactOutput,
	AddContactColumnParams
> {
	client = 'iam';
	document = gql`
		mutation AddContactColumn($input: AddContactColumnInput!) {
			addContactColumn(input: $input) {
				...Contact
			}
		}
		${contact}
	`;
	method = 'addContactColumn';
}
